
const AbsolutePathTagsReg = /^(https?:\/\/|\/)/;

const Util = {
  isAbsolutePath(path = '') {
    return AbsolutePathTagsReg.test(path);
  },

  formatTimestamp(timestamp, fmt = 'yyyy-MM-dd hh:mm:ss') {
		if (!timestamp) {
			return '';
		}

		try {
			var timeObj = new Date(parseInt(timestamp));
		} catch (e) {
			console.error(e);
			return timestamp;
		}

		const o = {
      'y+': timeObj.getFullYear(),
      'M+': timeObj.getMonth() + 1, // 月份
      'd+': timeObj.getDate(), // 日
      'h+': timeObj.getHours(), // 小时
      'm+': timeObj.getMinutes(), // 分
      's+': timeObj.getSeconds(), // 秒
      'q+': Math.floor((timeObj.getMonth() + 3) / 3), // 季度
      'S+': timeObj.getMilliseconds() // 毫秒
    };
    for (const k in o) {
      if (new RegExp('(' + k + ')').test(fmt)) {
        if (k == 'y+') {
          fmt = fmt.replace(RegExp.$1, ('' + o[k]).substr(4 - RegExp.$1.length));
        } else if (k == 'S+') {
          let lens = RegExp.$1.length;
          lens = lens == 1 ? 3 : lens;
          fmt = fmt.replace(RegExp.$1, ('00' + o[k]).substr(('' + o[k]).length - 1, lens));
        } else {
          fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (('00' + o[k]).substr(('' + o[k])
              .length)));
        }
      }
    }
    return fmt;
	},
  fillUrlWithParams(url, params) {
    let str = '';

    for (const key in params) {
      str += key + '=' + params[key] + '&';
    }

    if (str) {
      url = url + '?' + str.substring(0, str.length - 1);
    }

    return url;
  },
  // 两个数相减
  subtraction(arg1, arg2) {
    var re1, re2, m, n;
    try {
      re1 = arg1.toString().split('.')[1].length;
    } catch (e) {
      re1 = 0;
    }
    try {
      re2 = arg2.toString().split('.')[1].length;
    } catch (e) {
      re2 = 0;
    }
    m = Math.pow(10, Math.max(re1, re2));
    n = re1 >= re2 ? re1 : re2;
    return ((arg1 * m - arg2 * m) / m).toFixed(n);
  },
  // 将秒数转换为时分秒格式
  formatSeconds(value) {
    let theTime = value || 0; // 秒
    let middle = 0; // 分
    let hour = 0; // 小时

    if (theTime > 60) {
        middle = parseInt(theTime / 60);
        theTime = parseInt(theTime % 60);
        if (middle > 60) {
            hour = parseInt(middle / 60);
            middle = parseInt(middle % 60);
        }
    }
    let result = '';
    theTime = parseInt(theTime);
    middle = parseInt(middle);
    hour = parseInt(hour);
    if (hour === 0) {
        result = theTime + '秒';
        if (middle !== 0) {
            result = middle + '分钟' + result;
        }
    } else {
        result = theTime + '秒';
        result = middle + '分钟' + result;
        result = hour + '小时' + result;
    }

    return result;
  },
  initHistoryFix() {
    // 处理安卓机history.back()失效问题
    // 确保只在 Android WebView 中执行
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/android/i.test(userAgent)) {
      // 避免无限循环
      if (!sessionStorage.getItem('historyFixed')) {
        sessionStorage.setItem('historyFixed', 'true');
        window.history.pushState(null, document.title, window.location.href);
      }
    }
  }
};

export default Util;
